import React, {Component} from 'react';
import {connect} from 'react-redux';
import { Trans} from 'react-i18next';
import { Modal } from "react-bootstrap";
import { Cookies } from 'react-cookie';


import './VoteStatus.css';

class VoteStatus extends Component {

    constructor(props) {

        super(props);
        this.state = {
            hideAgeRestrictionPopup: false,
            showAgeRestrictionPopupErr: false
        }
        this.setAgeRestrictionAcceptance = this.setAgeRestrictionAcceptance.bind(this);
    }

    setAgeRestrictionAcceptance = () => {
        const cookies = new Cookies();
        console.log('cookie-set-here')
        cookies.set('age-restriction-' + this.props.competition.data.id, true);
        this.setState({
            hideAgeRestrictionPopup: true
        });
    }

    showAgeRestrictionPopupError = () => {
        this.setState({
            showAgeRestrictionPopupErr: true
        });
    }

    render() {

        const cookies = new Cookies();
        let modalContent = '';
        if (this.props.competition && this.props.competition.data
            && this.props.competition.data.showAgeRestrictionPopup) {
            console.log('p-nish', this.props.competition.data.showAgeRestrictionPopup);

            let noBorderRadius = (this.props.competition.data.defaultShape == 2);

            modalContent = (<Modal show={!cookies.get('age-restriction-' + this.props.competition.data.id)}
                dialogClassName={"loggingInModal " + (noBorderRadius ? 'no-border-radius' : '')}>
                <Modal.Body>
                    <div className={"age-restrict-dialog"}>
                        <div className={"modal-body"}>
                            <h3><Trans i18nKey="are_you_over_18" /></h3>
                        </div>
                        <div className={"modal-footer"}>
                            <button type="button" className={"btn btn-default"}
                                onClick={this.setAgeRestrictionAcceptance}><Trans i18nKey="yes" /></button>

                            <button type="button" className={"btn btn-default"}
                                onClick={this.showAgeRestrictionPopupError}><Trans i18nKey="no" /></button>
                            {this.state.showAgeRestrictionPopupErr ?
                                <div className={"modal-error"}><Trans i18nKey="are_you_over_18_err" /></div>
                                : ''
                            }
                        </div>
                    </div>
                </Modal.Body>
            </Modal>);
        }

        const currentRound = this.props.competition.currentRound;
        if(!currentRound) {
            return null;
        }

        return (
            <div className={`vote-status`}>
                {modalContent}
                {/* <div className={currentRound && currentRound.voteOpen ? 'open' : 'closed'}>
                    {currentRound && currentRound.voteOpen ?  <Trans i18nKey="now_open" /> : <Trans i18nKey="now_closed" />}!
                </div> */}
            </div>
        );
    }
}

//-------------------------------------------------------------------------
//-------------------- Mapping store to App's props ----------------------
//-------------------------------------------------------------------------

const mapStateToProps = (state, ownProps) => {

    const things = state.default;
    return {
        ...ownProps,
        competition: things.competition,
        auth: things.auth,
        locale: things.locale
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VoteStatus);
